import { render, staticRenderFns } from "./testPaperDialog.vue?vue&type=template&id=4d142864&scoped=true"
import script from "./testPaperDialog.vue?vue&type=script&lang=js"
export * from "./testPaperDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_n3acbem2au4l2e3t4qvos3rwwq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d142864",
  null
  
)

export default component.exports